import {Injectable} from '@angular/core';
import firebase from 'firebase';
import User = firebase.User;
import {BehaviorSubject} from 'rxjs';


@Injectable()
export class UserService {

    private user: any;
    private userSubject: BehaviorSubject<any> = new BehaviorSubject<any>({});
    public userSub = this.userSubject.asObservable();

    constructor() {
    }

    async setUser(session: User) {
        this.user = session;

        const doc = await firebase.firestore().collection('users').doc(session.uid).get();
        this.user.profile = doc.data();
        this.userSubject.next(this.user);
        return this.user;
    }

    getUser(): any {
        return this.user;
    }

    async singIn(email: string, password: string) {
        await firebase.auth().signInWithEmailAndPassword(email, password);
    }


    singOut() {
        firebase.auth().signOut();
    }
}
